import has from 'lodash/has';
import set from 'lodash/set';

export default (state, payload, resources) => {
  resources.forEach((resource) => {
    if (payload.pathname !== resource && has(state, resource)) {
      set(state, `${resource}.data`, {});
      set(state, `${resource}.list.ids`, []);
      set(state, `${resource}.list.total`, 0);
    }
  });
  console.log('state', state);
  return state;
};
